export default function concatClass() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  const classes = args.flat().filter(Boolean).join(" ");
  if (classes.length) {
    return classes;
  }
}